import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Mobile from '../views/M/Mobile1.vue'

// import Delivery from '../views/Delivery.vue'

Vue.use(VueRouter)
// -------- 统一处理 push、replace 的全局报错钩子------------------
// 消除 NavigationDuplicated 报错
const originalPush = VueRouter.prototype.push as any;
const originalReplace = VueRouter.prototype.replace as any;

VueRouter.prototype.push = function push(location: any, onResolve?: (...args: any[]) => any, onReject?: (err: Error) => void) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch((err: Error) => err);
};

VueRouter.prototype.replace = function replace(location: any, onResolve?: (...args: any[]) => any, onReject?: (err: Error) => void) {
    if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
    return originalReplace.call(this, location).catch((err: Error) => err);
};

// 判断是否为移动端
function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}


// pc路由
const pcRoutes = [
    {
      path: '/',
      name: 'Home',
      component:  Home,
    },
    {
      path: '/Campaign',
      name: 'Campaign',
      component:  Home,
    },
    {
      path: '/Flow',
      name: 'Flow',
      component:  Home,
    },
    {
      path: '/Tanchuan',
      name: 'Tanchuan',
      component:  Home,
    },
    {
      path: '/User',
      name: 'User',
      component:  Home,
    }
    
]
// 移动端路由
const mobileRoutes = [
    {
      path: '/',
      name: 'Home',
      component:  Home,
    },
    {
      path: '/Campaign',
      name: 'Campaign',
      component:  Home,
    },
    {
      path: '/Flow',
      name: 'Flow',
      component:  Home,
    },
    {
      path: '/Tanchuan',
      name: 'Tanchuan',
      component:  Home,
    },
    {
      path: '/User',
      name: 'User',
      component:  Home,
    }
]
const targetRoutes = isMobile() ? mobileRoutes : pcRoutes;

const routes = [
  // 改动前
  // isMobile() ? {
  //   path: '/',
  //   name: 'Home',
  //   component:  Mobile,
  // } : {path: '/',
  // name: 'Home',
  // component:  Home,},
  // {
  //   path: '/delivery',
  //   name: 'Delivery',
  //   // component: Delivery
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   component: () => import('../views/About.vue')
  // }


  // // 改动后
  // isMobile() ? {
  //   path: '/',
  //   name: 'Home',
  //   component: Home,
  // }: {
  //   path: '/',
  //   name: 'Home',
  //   component: Home,
  // }
  ...targetRoutes,
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
